module.exports = __webpack_public_path__ + "static/media/tubuli.4b390ebf.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Latium/tubuli.JPG
// module id = 687
// module chunks = 0